import EmptyBox from "components/atoms/boxs/EmptyBox/EmptyBox";
import AddInput from "components/atoms/inputs/AddInput/AddInput";
import CommonLine from "components/atoms/lines/CommonLine/CommonLine";
import CommonRowList from "components/organizations/lists/CommonRowList/CommonRowList";
import { useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUrlStore } from "store/url";
import { Context } from "utils/Context";
import { MainPageContainer } from "./MainPage.style";

const MainPage = () => {
  const { urls, addUrl, deleteUrl } = useUrlStore();
  const { setDialog } = useContext(Context);
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  const handleAddUrl = () => {
    if (!inputRef.current) return;
    const inputValue = inputRef.current.value;
    if (inputValue.length < 4) {
      setDialog("최소 4자리는 입력해주세요!", true);
      return;
    }
    if (urls.length === 4) {
      setDialog("최대 등록갯수는 4개입니다.", true);
      return;
    }
    if (urls.find((url) => url === inputValue)) {
      setDialog("이미 등록된 url입니다.", true);
      return;
    }
    addUrl(inputValue);
    inputRef.current.value = "";
  };
  const handleCardClick = (url: string) => {
    navigate(`/urldetail?url=${url}`);
  };
  const handleCardDeleteClick = (url: string) => {
    deleteUrl(url);
  };
  return (
    <MainPageContainer>
      <AddInput
        inputRef={inputRef}
        handleClick={handleAddUrl}
        buttonLabel={"추가"}
      />
      <CommonLine/>
      {urls.length === 0 ? (
        <EmptyBox />
      ) : (
        <CommonRowList
          data={urls}
          handleClick={handleCardClick}
          handleDeleteClick={handleCardDeleteClick}
        />
      )}
    </MainPageContainer>
  );
};

export default MainPage;
